// FAMILY-EXT: feature 1+2 — журнал ожиданий карточки.
// Каждая запись = один цикл "поставлено в ожидание → выполнено".
import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'CardWaitingAction';

  static fields = {
    id: attr(),
    text: attr(),
    createdAt: attr(),
    completedAt: attr(),
    // FAMILY-EXT: 'completed' | 'extended' | null
    closureType: attr(),
    cardId: fk({
      to: 'Card',
      as: 'card',
      relatedName: 'waitingActions',
    }),
    createdUserId: fk({
      to: 'User',
      as: 'createdUser',
      relatedName: 'createdWaitingActions',
    }),
    completedUserId: fk({
      to: 'User',
      as: 'completedUser',
      relatedName: 'completedWaitingActions',
    }),
  };

  static reducer({ type, payload }, CardWaitingAction) {
    switch (type) {
      case ActionTypes.LOCATION_CHANGE_HANDLE:
      case ActionTypes.CORE_INITIALIZE:
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        if (type === ActionTypes.SOCKET_RECONNECT_HANDLE) {
          CardWaitingAction.all().delete();
        }
        if (payload.cardWaitingActions) {
          payload.cardWaitingActions.forEach((a) => CardWaitingAction.upsert(a));
        }
        break;

      case ActionTypes.CARD_CREATE_HANDLE:
      case ActionTypes.CARD_UPDATE__SUCCESS:
      case ActionTypes.CARD_UPDATE_HANDLE:
        if (payload.cardWaitingActions) {
          payload.cardWaitingActions.forEach((a) => CardWaitingAction.upsert(a));
        }
        break;

      case ActionTypes.CARD_DELETE:
      case ActionTypes.CARD_DELETE__SUCCESS:
      case ActionTypes.CARD_DELETE_HANDLE: {
        const cardId = payload.id || (payload.card && payload.card.id);
        if (cardId) {
          CardWaitingAction.filter({ cardId }).delete();
        }
        break;
      }

      default:
    }
  }
}
